import React, { useEffect, useState, useRef } from 'react';
import { Root, Message } from './style';

import Modal from 'components/Common/Modal';

import hodlapp from 'assets/Claim/Connect/hodlapp.svg';
import metamask from 'assets/Claim/Connect/metamask.svg';
import trustwallet from 'assets/Claim/Connect/trustwallet.svg';
import safepal from 'assets/Claim/Connect/safepal.svg';
import wconnect from 'assets/Claim/Connect/walletconnect.svg';

import { getBalance, useWeb3, INJECTED, WALLETCONNECT } from 'web3';
import { useDashboard } from 'dashboard';

import LoadingOverlay from 'components/Common/LoadingOverlay';

import vars from 'variables';

const DashboardLayoutModal = ({ usedRef, onClose }) => {
  const modalRef = useRef();

  const CONNECT = 0;
  const SEARCH = 1;

  const [modalState, setModalState] = useState('');
  const [error, setError] = useState('');

  const { addWalletAddress, loadingOverlay } = useDashboard();
  const { connect } = useWeb3();

  const addAddress = (address) => {
    addWalletAddress(address);
    setTimeout(() => {
      onClose && onClose();
    }, 750);
  };

  const web3Connect = (loginType) => {
    modalRef.current.hide();
    connect(loginType)
      .then(addAddress)
      .catch(({ message }) => {
        if (message !== 'closed') {
          setError(message);
        } else {
          modalRef.current.show();
        }
      });
  };

  const verified = {};

  const isValid = async (value) => {
    value = value.replace(/\s/g, '').toLowerCase();

    let valid = verified[value];

    if (valid === undefined) {
      valid =
        value.match(/^0x[a-fA-F0-9]{40}$/) && (await getBalance(value)) > 0;
      verified[value] = valid;
    }

    return valid;
  };

  const onAddressChange = async (event) => {
    const input = event.target;
    const value = input.value;

    input
      .closest('form')
      .classList[(await isValid(value)) ? 'add' : 'remove']('valid');
  };

  const onSearchSubmit = async (event) => {
    event.preventDefault();

    const form = event.target;
    const input = form.getElementsByTagName('input')[0];
    const value = input.value;

    if (await isValid(value)) {
      addAddress(value.replace(/\s/g, '').toLowerCase());
      modalRef.current.hide();
    }
  };

  useEffect(() => {
    usedRef.current || (usedRef.current = {});
    usedRef.current.connect = () => {
      setError('');
      setModalState(CONNECT);
      modalRef.current.show();
    };
    usedRef.current.search = () => {
      setError('');
      setModalState(SEARCH);
      modalRef.current.show();
    };
  });

  return (
    <Root>
      <Modal
        className={modalState === CONNECT ? 'scaled-07' : ''}
        usedRef={modalRef}
        onClose={() => window.scrollTo(0, 0)}
      >
        {error ? (
          <Message className="error">
            <h4>
              <span>Something went wrong</span>
            </h4>
            <h2>Oops! {error}</h2>
            <a
              className="button blue logo"
              href={vars.links.buy}
              target="_blank"
              rel="noreferrer"
            >
              Buy HODL now
            </a>
          </Message>
        ) : (
          ''
        )}
        {!error && modalState === CONNECT ? (
          <Message>
            <h3>Connect your wallet</h3>
            <ul>
              {window.ethereum?.isHODLApp ? (
                <li onClick={() => web3Connect(INJECTED)}>
                  <strong>HODL App</strong>
                  <img src={hodlapp} />
                </li>
              ) : null}
              <li onClick={() => web3Connect(INJECTED)}>
                <strong>MetaMask</strong>
                <img src={metamask} />
              </li>
              <li onClick={() => web3Connect(INJECTED)}>
                <strong>Trust Wallet</strong>
                <img src={trustwallet} />
              </li>
              <li onClick={() => web3Connect(INJECTED)}>
                <strong>SafePal</strong>
                <img src={safepal} />
              </li>
              <li className="hr">
                <span>or</span>
              </li>
              <li onClick={() => web3Connect(WALLETCONNECT)}>
                <strong>WalletConnect</strong>
                <img src={wconnect} />
              </li>
            </ul>
          </Message>
        ) : (
          ''
        )}
        {!error && modalState === SEARCH ? (
          <Message className="search-modal">
            <h3>Enter wallet address</h3>
            <form onSubmit={onSearchSubmit}>
              <input type="text" onChange={onAddressChange} autoFocus />
              <button></button>
            </form>
          </Message>
        ) : (
          ''
        )}
      </Modal>
      <LoadingOverlay usedRef={loadingOverlay} />
    </Root>
  );
};

export default DashboardLayoutModal;
